// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__yk7_n"};